{
  "id": "birdhouse",
  "name": "Birdhouse",
  "builds": "product",
  "category": "rustic",
  "note": "The slit between the front boards is the door. Wrens aren't picky.",
  "skill": "rusticProjects",
  "duration": 25,
  "offeredBy": "hammer",
  "fastener": "nails",
  "value": 10,
  "widthIn": 15,
  "heightIn": 16,
  "slots": [
    {
      "id": "front-0",
      "role": "front",
      "part": {
        "widthIn": 4,
        "lengthIn": 12,
        "thicknessQ": 4,
        "ends": {
          "left": {
            "kind": "mitered",
            "angle": 45
          },
          "right": {
            "kind": "square"
          }
        }
      },
      "stock": {
        "type": "board"
      },
      "xIn": 5,
      "yIn": 10,
      "angleDeg": 0,
      "zIn": 4
    },
    {
      "id": "front-1",
      "role": "front",
      "part": {
        "widthIn": 4,
        "lengthIn": 12,
        "thicknessQ": 4,
        "ends": {
          "left": {
            "kind": "mitered",
            "angle": 45
          },
          "right": {
            "kind": "square"
          }
        }
      },
      "stock": {
        "type": "board"
      },
      "xIn": 10,
      "yIn": 10,
      "angleDeg": 0,
      "zIn": 4
    },
    {
      "id": "roof-0",
      "role": "roof",
      "part": {
        "widthIn": 4,
        "lengthIn": 12,
        "thicknessQ": 4
      },
      "stock": {
        "type": "board"
      },
      "xIn": 7.5,
      "yIn": 3.5,
      "angleDeg": 90,
      "zIn": 5
    },
    {
      "id": "side-0",
      "role": "side",
      "part": {
        "widthIn": 4,
        "lengthIn": 6,
        "thicknessQ": 4
      },
      "stock": {
        "type": "board"
      },
      "xIn": 3.5,
      "yIn": 12,
      "angleDeg": 0,
      "zIn": 0,
      "onEdge": true
    },
    {
      "id": "side-1",
      "role": "side",
      "part": {
        "widthIn": 4,
        "lengthIn": 6,
        "thicknessQ": 4
      },
      "stock": {
        "type": "board"
      },
      "xIn": 11.5,
      "yIn": 12,
      "angleDeg": 0,
      "zIn": 0,
      "onEdge": true
    },
    {
      "id": "floor-0",
      "role": "floor",
      "part": {
        "widthIn": 4,
        "lengthIn": 12,
        "thicknessQ": 4
      },
      "stock": {
        "type": "board"
      },
      "xIn": 7.5,
      "yIn": 15.5,
      "angleDeg": 90,
      "zIn": 0,
      "onEdge": true
    }
  ],
  "fasteners": [
    {
      "xIn": 6.5,
      "yIn": 5
    },
    {
      "xIn": 11.5,
      "yIn": 5
    },
    {
      "xIn": 3.5,
      "yIn": 12
    },
    {
      "xIn": 11.5,
      "yIn": 12
    },
    {
      "xIn": 5,
      "yIn": 15.5
    },
    {
      "xIn": 10,
      "yIn": 15.5
    }
  ]
}
